export const LANGUAGE_OPTIONS = [
  { code: 'zh', label: '简体中文', short: '中文' },
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'pt', label: 'Português', short: 'PT' },
  { code: 'th', label: 'ไทย', short: 'TH' },
  { code: 'vi', label: 'Tiếng Việt', short: 'VN' },
  { code: 'my', label: 'မြန်မာ', short: 'MM' },
];

export const SUPPORTED_LANGUAGES = LANGUAGE_OPTIONS.map(item => item.code);

const LANGUAGE_ALIASES = {
  mm: 'my',
  'my-mm': 'my',
  'my_mm': 'my',
  bur: 'my',
  mya: 'my',
};

// 旧首页和游戏页一直读取 locale，因此迁移时优先采用它。
const USER_LANGUAGE_KEYS = ['locale', 'lang', 'language'];

export function normalizeLanguage(language, fallback = 'vi') {
  const aliased = LANGUAGE_ALIASES[language] || language;
  return SUPPORTED_LANGUAGES.includes(aliased) ? aliased : fallback;
}

export function getLanguageShortName(language, fallback = 'vi') {
  const item = LANGUAGE_OPTIONS.find(option => option.code === language);
  if (item) {
    return item.short;
  }
  const fallbackItem = LANGUAGE_OPTIONS.find(option => option.code === fallback);
  return (fallbackItem && fallbackItem.short) || String(language || fallback).toUpperCase();
}

export function getUserLanguage() {
  for (let index = 0; index < USER_LANGUAGE_KEYS.length; index += 1) {
    const key = USER_LANGUAGE_KEYS[index];
    const language = normalizeLanguage(localStorage.getItem(key), '');
    if (language) {
      return language;
    }
  }

  return '';
}

export function saveUserLanguage(language) {
  const normalizedLanguage = normalizeLanguage(language);
  USER_LANGUAGE_KEYS.forEach(key => localStorage.setItem(key, normalizedLanguage));
  return normalizedLanguage;
}

export function getCachedDefaultLanguage() {
  try {
    const appInfo = JSON.parse(localStorage.getItem('appInfo') || '{}');
    return normalizeLanguage(appInfo.default_language);
  } catch (error) {
    return 'vi';
  }
}



// WEBPACK FOOTER //
// ./src/utils/language.js